export default {
    getSimpleMessageCount: '/auth/message/getSimpleMessageCount',
    getSimpleMessageList: '/auth/message/getSimpleMessageList',
    clickSimpleMessage: '/auth/message/clickSimpleMessage',
    sendMessage: '/auth/message/add/simpleMessage',
}


// WEBPACK FOOTER //
// ./src/axios/api_urls/messageCenter.js